import { ResumeHandlerProps } from "../types/resume";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { useAppDispatch } from "../../../../../hooks/reduxHooks";
import { updateResume } from "../../../../../lib/api";
import { serializeForm } from "../../../../../lib/utils";

const useResumeHandlers = ({
    selectedTeam,
    setSending,
}: ResumeHandlerProps) => {
    const dispatch = useAppDispatch();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        setSending(true);
        e.preventDefault();
        const formData = serializeForm(new FormData(e.currentTarget));

        try {
            await updateResume(formData, selectedTeam!.id);
            dispatch(
                alertActions.success({
                    title: "Resume updated successfully",
                    dismissible: true,
                }),
            );
        } catch (error: any) {
            dispatch(
                dispatch(
                    alertActions.error({
                        title: "The server encountered a problem updating your resume.",
                        text: "If the problem continues, please reach out to an admin.",
                        dismissible: true,
                    }),
                ),
            );
        } finally {
            setSending(false);
        }
    };

    return { handleSubmit };
};

export default useResumeHandlers;
